module.exports = __webpack_public_path__ + "media/plans/small-977ba58c.png";